"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Privileges = exports.PrivilegeOptions = void 0;
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class PrivilegeOptions {
}
exports.PrivilegeOptions = PrivilegeOptions;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEnum)(constants_1.ActionEnum, { each: true }),
    (0, property_1.Property)({ type: [String], enum: constants_1.ActionEnum }),
    __metadata("design:type", Array)
], PrivilegeOptions.prototype, "allowedActions", void 0);
class Privileges {
}
exports.Privileges = Privileges;
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "users", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "admins", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "visits", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "healthFacilities", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "adminLogs", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "discounts", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "serverConfigs", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "specializations", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "transactions", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "notifications", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "analytics", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "calls", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PrivilegeOptions),
    (0, property_1.Property)(),
    __metadata("design:type", PrivilegeOptions)
], Privileges.prototype, "clientErrors", void 0);
